<!--
     <InputMetricCategory
       :initial_value='{text: "My label", value: 69}'
       :metric_config='{}'
       readonly
       required
       @change="handler(value)"
     />

     Public propertys:
       value → Gives the field's serializable value

     Public methods:
       validate → Makes validation and returns if the value is valid
-->

<template>
  <v-select
    v-model="input_value"
    :items="select_items"
    :label="label || ''"
    :readonly="readonly"
    item-text="text"
    item-value="value"
    :rules="[is_required]"
    :class="readonly ? 'qmkey-form-input-readonly': 'qmkey-form-input'"
    outlined
    dense
    return-object
    background-color="#f2f2f2"
    :clearable="required && !readonly"
    :disabled="readonly"
  >
    <template>
      <v-icon slot="append" color="primary" v-if="!readonly">
        {{ false || "mdi-menu-down" }}
      </v-icon>
      <div v-else slot="append"></div> <!-- Hide icon -->
    </template>
  </v-select>
</template>

<style lang="scss">
 @import "@/sass/variables.scss";
</style>

<script>
 export default {
   name: 'InputMetricCategory',

   props: {
     metric_config: {required: true},
     initial_value: {required: false, default: null},
     readonly: {required: false, default: false},
     required: {required: false, default: false},
     label: {required: false, default: ''},
   },

   data: () => ({
     input_value: null,
     no_emit: false,
   }),

   mounted() {
     this.pull_value(this.initial_value);
   },

   computed: {
     value() {
       return (this.input_value || {}).text;
     },

     select_items() {
       return (Object
         .entries(this.metric_config.categories)
         .map(([cat, value]) => ({
           text: cat,
           value: value,
         })));
     },
   },

   methods: {
     validate() {
       return true; // TODO
     },

     async pull_value(val) {
       // val → "Name"
       this.no_emit = true;
       this.input_value = (this.select_items || []).filter(it => it.text == val)[0];
       await this.$nextTick();
       this.no_emit = false;
     },

     is_required(value) {
       // TODO: Multilang: Change hardcoded string
       return (value !== null
            || value !== undefined
            || !this.required
            || this.$vuetify.lang.translator('required_field'));
     },

     emit_change(val) {
       val = val !== undefined ? val : (this.input_value || {}).text;
       this.$emit('change', val);
     },
   },

   watch: {
     input_value(val) {
      if (!this.no_emit && val) {
        this.emit_change(val.text);
      }
     },

     initial_value(val) {
       this.pull_value(val);
     },
   }
 };
</script>
